export const KINERJA_PENILIK_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY =
  'kinerja-ps-perencanaan-praktik-kinerja-draft'

export const KINERJA_PENILIK_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY =
  'kinerja-penilik-pegawai-perencanaan-perilaku-kerja-draft'

export const KINERJA_PENILIK_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY =
  'kinerja-penilik-pegawai-perencanaan-pengembangan-kompetensi-draft'
